import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8 relative overflow-hidden" data-id="element-178">
      {/* Decorative Gold Blob */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-179" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-card border-2 border-gold/40 rounded-3xl px-6 py-10 md:p-12 shadow-gold text-center space-y-8" data-id="element-181">
          {/* 1. TITULAR — resultado */}
          <div className="space-y-2" data-id="element-182">
            <h2 className="text-2xl md:text-3xl font-display font-extrabold leading-tight" data-id="element-183">
              Empezá a desinflamarte
              <br data-id="element-184" />
              <span className="text-gradient-gold" data-id="element-185">
                en los próximos 21 días
              </span>
            </h2>
            <p className="text-sm md:text-base text-foreground/60 font-body font-medium" data-id="element-186">
              Acceso completo al Protocolo H.E.R.
            </p>
          </div>

          {/* 2. PRECIO ANCLA + PRECIO ACTUAL */}
          <div className="space-y-3" data-id="element-187">
            <p className="text-lg md:text-xl text-foreground/40 font-body font-medium line-through decoration-foreground/25 decoration-2" data-id="element-188">
              $69.000 ARS
            </p>
            <div data-id="element-189">
              <p className="text-[15px] md:text-base text-foreground/70 font-body font-semibold mb-1" data-id="element-190">
                Hoy podés empezar por solo
              </p>
              <p className="text-6xl md:text-7xl font-display font-black text-gradient-gold glow-gold leading-none" data-id="element-191">
                $12.000
              </p>
              <p className="text-sm text-foreground/50 font-body font-medium mt-1.5" data-id="element-192">
                ARS · pago único
              </p>
            </div>
          </div>

          {/* 3. CUOTAS */}
          <div className="bg-gold/5 border border-gold/20 rounded-xl px-5 py-3.5 max-w-sm mx-auto" data-id="element-193">
            <p className="text-sm md:text-base font-body font-semibold text-foreground/80 leading-snug" data-id="element-194">
              💳 O en 3 cuotas sin interés de $4.000
            </p>
            <p className="text-xs text-foreground/50 font-body font-medium mt-0.5" data-id="element-195">
              con Mercado Pago
            </p>
          </div>

          {/* 4. FRASE EMOCIONAL — remueve objeción */}
          <p className="text-base md:text-lg font-body font-medium italic max-w-sm mx-auto leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.75)'
        }} data-id="element-196">
            Menos de lo que gastás en una semana en cosas que no te cambian
            nada.
          </p>

          {/* 5. CTA PRINCIPAL */}
          <div className="pt-2" data-id="element-197">
            <CTAButton className="w-full md:w-auto text-lg md:text-xl" data-id="element-198">
              QUIERO VOLVER A SENTIRME BIEN
            </CTAButton>
          </div>

          {/* 6. BENEFICIOS DE COMPRA — 3 bullets */}
          <div className="flex flex-col items-center gap-2.5 max-w-xs mx-auto" data-id="element-199">
            <div className="flex items-center gap-2.5" data-id="element-200">
              <span className="text-base" data-id="element-201">⚡</span>
              <span className="text-[13px] md:text-sm text-foreground/80 font-body font-medium" data-id="element-202">
                Acceso inmediato al programa completo
              </span>
            </div>
            <div className="flex items-center gap-2.5" data-id="element-203">
              <span className="text-base" data-id="element-204">♾️</span>
              <span className="text-[13px] md:text-sm text-foreground/80 font-body font-medium" data-id="element-205">
                Lo comprás una vez y es tuyo para siempre
              </span>
            </div>
            <div className="flex items-center gap-2.5" data-id="element-206">
              <span className="text-base" data-id="element-207">🎁</span>
              <span className="text-[13px] md:text-sm text-foreground/80 font-body font-medium" data-id="element-208">
                5 bonos exclusivos incluidos sin costo extra
              </span>
            </div>
          </div>

          {/* Divider */}
          <div className="w-20 h-px bg-gold/20 mx-auto" data-id="element-209" />

          {/* 7. URGENCIA */}
          <div className="space-y-1" data-id="element-210">
            <p className="text-sm md:text-base text-accent font-body font-bold" data-id="element-211">
              ⏳ Precio de lanzamiento por tiempo limitado
            </p>
            <p className="text-sm text-foreground/50 font-body font-medium" data-id="element-212">
              Después vuelve a $69.000
            </p>
          </div>

          {/* 8. GARANTÍA — bloque separado */}
          <div className="bg-secondary/10 border border-secondary/20 rounded-2xl px-6 py-6 max-w-md mx-auto space-y-3" data-id="element-213">
            <div className="flex items-center justify-center gap-2" data-id="element-214">
              <span className="text-2xl" data-id="element-215">🛡️</span>
              <span className="text-secondary font-bold font-display text-base md:text-lg" data-id="element-216">
                Garantía de 30 días
              </span>
            </div>
            <p className="text-[13px] md:text-sm text-foreground/70 font-body font-medium leading-relaxed" data-id="element-217">
              Probalo con calma. Si no es para vos, me escribís y te devuelvo el
              100%.
              <br data-id="element-218" />
              <span className="font-bold" data-id="element-219">Sin vueltas ni condiciones.</span>
            </p>
          </div>

          {/* 9. SELLOS DE CONFIANZA */}
          <div className="space-y-4" data-id="element-220">
            <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-221">
              <span className="text-[13px] md:text-sm text-foreground/60 font-body font-medium" data-id="element-222">
                🔒 Pago 100% seguro
              </span>
              <span className="text-[13px] md:text-sm text-foreground/60 font-body font-medium" data-id="element-223">
                ✅ Satisfacción garantizada
              </span>
              <span className="text-[13px] md:text-sm text-foreground/60 font-body font-medium" data-id="element-224">
                ⚡ Acceso inmediato
              </span>
            </div>
            <div className="flex flex-col items-center gap-3" data-id="element-225">
              <img src="https://cdn.magicpatterns.com/uploads/7qHzDsLZQadSacwja9UfzV/sellos_2.png" alt="Visa, Mastercard, American Express, PayPal, Mercado Pago" className="w-48 md:w-56 h-auto" data-id="element-226" />
              <img src="https://cdn.magicpatterns.com/uploads/tdA4AqADhgGePmHY6mrLkM/nb2-1775758553264-1.png" alt="Garantía 30 días devolución de dinero y SSL Seguro" className="w-40 md:w-48 h-auto" data-id="element-227" />
            </div>
          </div>
        </motion.div>

        {/* Emotional closer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-2xl mx-auto mt-12 space-y-3" data-id="element-228">
          <p className="text-xl md:text-2xl font-display font-bold text-gradient-gold leading-snug" data-id="element-229">
            No es tu cuerpo el problema
          </p>
          <p className="text-base md:text-lg font-body font-medium leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.85)'
        }} data-id="element-230">
            Tu cuerpo no está fallando. Está cambiando. Y cuando entendés cómo
            funciona, todo empieza a ordenarse.
          </p>
        </motion.div>
      </div>
    </section>;
}